import Check from './Check.jsx';

export const PAYMENT_METHODS = {
    'stripe_creditcard': 'Kreditkarte',
    'stripe_sofort': 'Sofort',
    'stripe_giropay': 'Giropay',
    'invoice': 'Rechnung',
    'stripe_paypal': 'PayPal',
};

export default function PaymentMethod({ method, selected, onSelect }) {
    return (
        <div className="flex flex-col items-center mr-4">
          <button onClick={() => onSelect()}
                  className={`w-32 px-2 py-2 flex justify-center items-center relative bg-white h-16 rounded-lg drop-shadow-md ${selected ? 'border-gold border-2' : ''}`}>
            <img alt={PAYMENT_METHODS[method]} className="h-auto w-20" src={`/assets/images/${method}.png`}/>
            {selected && <div style={{right: -12, top: -12}} className="w-6 h-6 rounded-full bg-gold absolute text-white flex items-center justify-center"><Check/></div>}
          </button>
          <div className={`text-sm mt-1  ${selected ? '' : 'opacity-60'}`}>{PAYMENT_METHODS[method]}</div>
        </div>
    );
}

